import { useLocalization } from '@/hooks/useLocalization';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import { FORMAT_OPTIONS } from '@/utils/constants';

export default function FormatScreen() {
  const { t } = useLocalization();
  const { chooseFormat } = useChat();

  return (
    <BotMessage text={t('format.message')}>
      <ScreenOptions>
        {FORMAT_OPTIONS.map(opt => (
          <OptionButton key={opt.value} onClick={() => chooseFormat(opt.value)}>
            {t(opt.labelKey)}
          </OptionButton>
        ))}
      </ScreenOptions>
    </BotMessage>
  );
}
